import * as _ from "lodash";
import * as angular from "angular";
import { Effort } from "./effort.model";

export class DashboardWidgetFilter {
    public dateRange: any = {
        selectedTemplate: "Last 30 Days",
        selectedTemplateName: "Last 30 Days",
        dateStart: new Date(new Date().setDate(new Date().getDate() - 29)),
        dateEnd: new Date(),
    };
    public app_type: string = null;
    public effort: Effort = null;
    public order: { column: string | null; direction: string | null };
    public dateBasedOn: string = "interaction";
    public users: any[] = [];
    public teams: any[] = [];
    public groups: any[] = [];
    public campaigns: any[] = [];
    public selected: any[] = [];
    public countType: string = "total";
    public dataTypeSpecificFilter = null;
    public permissionIds: number[] = [];
    public target: object = {
        daily: 100,
        hourly: 25,
        leads_generated: 1,
        shift_duration: 4,
    };

    constructor(data?: any) {
        this.setData(data);
    }

    reset() {
        this.users = [];
        this.teams = [];
        this.campaigns = [];
        this.groups = [];
        this.selected = [];
        this.effort = null;
        this.app_type = null;
    }

    numActive() {
        let count: number = 0;
        if (
            (this.users && this.users.length > 0) ||
            (this.teams && this.teams.length > 0)
        ) {
            count++;
        }
        if (this.groups && this.groups.length > 0) {
            count++;
        }
        if (this.campaigns && this.campaigns.length > 0) {
            count++;
        }
        if (this.effort != null) {
            count++;
        }
        if (this.app_type != null) {
            count++;
        }
        if (
            this.dateRange != null &&
            Object.keys(this.dateRange).length &&
            ((this.dateRange.selectedTemplate &&
                this.dateRange.selectedTemplate != "") ||
                this.dateRange.dateStart ||
                this.dateRange.dateEnd)
        ) {
            count++;
        }
        return count;
    }

    setData(data: any): void {
        _.merge(this, data);
        this.groups = data && data.groups ? data.groups : [];
        this.users = data && data.users ? data.users : [];
        this.teams = data && data.teams ? data.teams : [];
        this.campaigns = data && data.campaigns ? data.campaigns : [];
        this.selected = data && data.selected ? data.selected : [];
        this.app_type = data && data.app_type ? data.app_type : null;
        this.dateBasedOn = data && data.dateBasedOn ? data.dateBasedOn : null;
        this.countType = data && data.countType ? data.countType : "total";
        this.permissionIds =
            data && data.permissionIds ? data.permissionIds : null;

        if (data && data.order) {
            this.order = data.order;
        }

        if (this.dateRange) {
            if (
                this.dateRange.dateStart &&
                typeof this.dateRange.dateStart == "string"
            ) {
                this.dateRange.dateStart = new Date(this.dateRange.dateStart);
            }

            if (
                this.dateRange.dateEnd &&
                typeof this.dateRange.dateEnd == "string"
            ) {
                this.dateRange.dateEnd = new Date(this.dateRange.dateEnd);
            }
        }

        if (data && data.dataTypeSpecificFilter) {
            this.dataTypeSpecificFilter = data.dataTypeSpecificFilter;
        }

        if (this.dateRange.selectedTemplate) {
            angular.forEach(
                this.getCustomDateTemplates(),
                (templateObj: any) => {
                    if (this.dateRange.selectedTemplate == templateObj.name) {
                        this.dateRange.dateStart = templateObj.dateStart;
                        this.dateRange.dateEnd = templateObj.dateEnd;
                    }
                }
            );
        }
    }

    getCustomDateTemplates() {
        let lessThan3Day = new Date();
        let lessThan7Day = new Date();
        let lessThan30Day = new Date();
        let lessThan90Day = new Date();
        let lessThan5Year = new Date();

        return [
            {
                name: "Last 3 Days",
                dateStart: new Date(
                    lessThan3Day.setDate(lessThan3Day.getDate() - 2)
                ),
                dateEnd: new Date(),
            },
            {
                name: "Last 7 Days",
                dateStart: new Date(
                    lessThan7Day.setDate(lessThan7Day.getDate() - 6)
                ),
                dateEnd: new Date(),
            },
            {
                name: "Last 30 Days",
                dateStart: new Date(
                    lessThan30Day.setDate(lessThan30Day.getDate() - 29)
                ),
                dateEnd: new Date(),
            },
            {
                name: "Last 90 Days",
                dateStart: new Date(
                    lessThan90Day.setDate(lessThan90Day.getDate() - 89)
                ),
                dateEnd: new Date(),
            },
            {
                name: "All Time",
                dateStart: new Date(
                    lessThan5Year.setDate(lessThan90Day.getDate() - 1825)
                ),
                dateEnd: new Date(),
            },
        ];
    }

    setCombinedData(data: any): void {
        this.groups = data && data.groups ? data.groups : [];
        this.users = data && data.users ? data.users : [];
        this.teams = data && data.teams ? data.teams : [];
        this.campaigns = data && data.campaigns ? data.campaigns : [];
        this.selected = data && data.selected ? data.selected : [];
        this.effort = data && data.effort ? data.effort : null;
        this.app_type = data && data.app_type ? data.app_type : null;
        this.dateRange = data && data.dateRange ? data.dateRange : {};
        this.dateBasedOn = data && data.dateBasedOn ? data.dateBasedOn : null;
        this.countType = data && data.countType ? data.countType : "total";
        this.permissionIds =
            data && data.permissionIds ? data.permissionIds : [];

        if (data && data.order) {
            this.order = data.order;
        }
    }

    combineWithGlobal(
        globalFilter: DashboardWidgetFilter
    ): DashboardWidgetFilter {
        let copy = angular.copy(this);

        copy.users =
            globalFilter.users && globalFilter.users.length > 0
                ? globalFilter.users
                : this.users;

        copy.teams =
            globalFilter.teams && globalFilter.teams.length > 0
                ? globalFilter.teams
                : this.teams;

        copy.campaigns =
            globalFilter.campaigns && globalFilter.campaigns.length > 0
                ? globalFilter.campaigns
                : this.campaigns;

        copy.groups =
            globalFilter.groups && globalFilter.groups.length > 0
                ? globalFilter.groups
                : this.groups;

        copy.selected =
            globalFilter.selected && globalFilter.selected.length > 0
                ? globalFilter.selected
                : this.selected;

        copy.permissionIds =
            globalFilter.permissionIds && globalFilter.permissionIds.length > 0
                ? globalFilter.permissionIds
                : this.permissionIds;

        copy.effort = globalFilter.effort ? globalFilter.effort : this.effort;

        copy.app_type = globalFilter.app_type
            ? globalFilter.app_type
            : this.app_type;

        copy.dateRange =
            globalFilter &&
            globalFilter.dateRange &&
            globalFilter.dateRange.selectedTemplateName
                ? globalFilter.dateRange
                : copy.dateRange;

        return copy;
    }
}
